import type { CharacterConfig } from '../../src/characters/types';
import modelUrl from './runtime/model/mizuki.fbx?url';
import bodyUrl from './runtime/textures/diffuse/body.png?url';
import faceUrl from './runtime/textures/diffuse/face.png?url';
import hairUrl from './runtime/textures/diffuse/hair.png?url';
import bodyLightmapUrl from './runtime/textures/lightmap/body.png?url';
import hairLightmapUrl from './runtime/textures/lightmap/hair.png?url';
import bodyRampUrl from './runtime/textures/ramp/body.png?url';
import hairRampUrl from './runtime/textures/ramp/hair.png?url';
import faceSdfUrl from './runtime/textures/sdf/face.png?url';
import faceShadowUrl from './runtime/textures/shadow/face.png?url';

export const mizukiCharacter = {
  id: 'mizuki', label: 'Mizuki', slug: 'mizuki', assetRoot: 'characters/mizuki/runtime', modelUrl,
  textures: {
    body: bodyUrl, face: faceUrl, hair: hairUrl,
    bodyLightmap: bodyLightmapUrl, bodyRamp: bodyRampUrl,
    hairLightmap: hairLightmapUrl, hairRamp: hairRampUrl, faceSdf: faceSdfUrl, faceShadow: faceShadowUrl,
  },
  materialRules: [
    { mesh: 'EyeStar', diffuse: 'face', glow: 'eye' },
    { mesh: 'Brow', diffuse: 'face', lighting: 'face' },
    { meshPattern: /^(Face|Face_Eye)$/, diffuse: 'face', lighting: 'face', maskedEyeGlow: true, faceCheekRim: true },
    { materialPattern: /_Mat_Hair$/i, diffuse: 'hair', lighting: 'hair', glow: 'subtle' },
    { materialPattern: /_Mat_(Body|Dress)$/i, diffuse: 'body', lighting: 'body', glow: 'subtle' },
  ],
  shading: {
    hairShadowTint: [.74264705, .666198, .6804334],
    bodyShadowTint: [.74264705, .666198, .6804334],
    faceShadowColor: [.9490196, .7921569, .78039217],
  },
  outline: { enabled: true, hairColor: 0x344952, bodyColor: 0x4e385c, hairWidth: .008, bodyWidth: .005 },
  capabilities: { faceSdf: true, maskedEyeEmission: true, outline: true },
} as const satisfies CharacterConfig<'mizuki'>;
